<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              :pageId="pageId"
              :selectedMd="batchJobData.moduleCode"
              :selectedSmd="batchJobData.subModuleCode"
              :disabled="true"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_ID')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.batchJobId"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.batchJobName"
              max-length="100"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CYCL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.batchJobCycle"
              max-length="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IF_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.interfaceId"
              max-length="100"
              @keyup="onKeyUpInput($event, batchJobData, 'interfaceId')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.beforeBatchJobId"
              max-length="100"
              @keyup="onKeyUpInput($event, batchJobData, 'beforeBatchJobId')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_AF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.afterBatchJobId"
              max-length="100"
              @keyup="onKeyUpInput($event, batchJobData, 'afterBatchJobId')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-program-select
              :selectedPrg="selectedPrg"
              readonly
              @selected="onSelectedPrg"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_PRTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="batchJobData.batchJobPracticeYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="batchJobData.batchJobPracticeYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-5" />
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model.trim="batchJobData.batchJobContent"
              name="name"
              rows="5"
              maxlength="400"
              class="width100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="batchJobData.registrationDisplayLanguageId"
              :knoxId="batchJobData.registrationKnoxId"
              :userName="batchJobData.registrationUserName"
              :userGlobalName="batchJobData.registrationUserGlobalName"
              :departmentName="batchJobData.registrationDepartmentName"
              :departmentEnglishName="batchJobData.registrationDepartmentGlobalName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            {{ batchJobData.firstRegistrationDTM }}
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="batchJobData.modificationDisplayLanguageId"
              :knoxId="batchJobData.modificationKnoxId"
              :userName="batchJobData.modificationUserName"
              :userGlobalName="batchJobData.modificationUserGlobalName"
              :departmentName="batchJobData.modificationDepartmentName"
              :departmentEnglishName="batchJobData.modificationDepartmentGlobalName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            {{ batchJobData.finalModificationDTM }}
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btnBot_wrap mrL30 mrR30">
      <div class="btn_wrapL">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onPopOpenOrClose"
        >
          {{ $t("MSG_BTN_HIS_SRCH") }}
        </sui-button>
      </div>
      <div class="btn_wrapR">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClose"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_border"
          @click="onDelete"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:update="pageId"
          type="button"
          class="comm_btn_solid"
          @click="onSave"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
      </div>
    </div>

    <!-- compoenets -->
    <sui-popup
      v-model="isShowPopUpJobHistory"
      :title="$t('MSG_TXT_BCJB_HIS_LIST')"
    >
      <p03
        :pageId="pageId"
        :batchJobId="batchJobId"
        @close="onPopOpenOrClose"
      />
    </sui-popup>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

import p03 from './PGE_CMS_00004_P03';

export default {
  name: 'PGE_CMS_00004_P02', // eslint-disable-line vue/name-property-casing
  components: {
    p03,
  },
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00004',
    },
    batchJobId: {
      type: String,
      required: true,
      validator(value) {
        return (utils.isEmpty(value) === false);
      },
    },
  },
  data() {
    return {
      isShowPopUpJobHistory: false,

      selectedPrg: {
        programName: '',
        programId: '',
      },

      searchFieldOldText: {},

      batchJobData: {
        moduleCode: { key: '', label: '' },
        moduleName: '',
        subModuleCode: { key: '', label: '' },
        subModuleName: '',
        batchJobId: '',
        batchJobName: '',
        batchJobCycle: '',
        interfaceId: '',
        beforeBatchJobId: '',
        afterBatchJobId: '',
        batchJobProgramId: '',
        batchJobProgramName: '',
        batchJobContent: '',


        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        finalModificationUserId: '',
        finalModificationDTM: '',

        registrationKnoxId: '',
        registrationUserName: '',
        registrationUserGlobalName: '',
        registrationDepartmentName: '',
        registrationDepartmentGlobalName: '',
        registrationDisplayLanguageId: '',

        modificationKnoxId: '',
        modificationUserName: '',
        modificationUserGlobalName: '',
        modificationDepartmentName: '',
        modificationDepartmentGlobalName: '',
        modificationDisplayLanguageId: '',

        batchJobPracticeYn: '',
      },

      batchJobHistorySearchBox: {
        batchJobId: '',
        batchJobSuccessYn: { key: '', label: '' },
        batchJobStartDTM: '',
        batchJobEndDTM: '',
      },

      rangeDate: {
        from: '',
        to: '',
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_BCJB_PRTC_ID'),
        datafield: 'batchJobPracticeId',
        width: '330px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
            type: 'sublink',
          }, this.dsBatchJob, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PROC_DTM'),
        datafield: 'batchJobGenerateDTM',
        width: '150px',
        cellsrenderer: (r, c, v, h, p) => utils.dateCellRenderer(r, c, v, h, p),
      }, {
        text: this.$t('MSG_TXT_PROC_YN'),
        datafield: 'batchJobSuccessYn',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ERR_CD'),
        datafield: 'batchJobErrorCode',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ERR_CNTN'),
        datafield: 'batchJobErrorContent',
      }, {
        text: this.$t('MSG_TXT_PRTC_CNTN'),
        datafield: 'batchJobPracticeContent',
      }],
    };
  },
  datasets: [{
    id: 'dsBatchJob',
    type: 'local',
    data: 'localdata0',
    datafields: [],
  }],
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    this.searchBatchJob(this.batchJobId);
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    // 내부 함수 기술
    // 이벤트 핸들러 기술, prefix on 적용
    onGridButtonClicked(btn, rowData) {
      utils.openLayerPopup('PGE_CMS_00007', this.onPagePopupClose, {
        pageInitialData: {
          batchJobId: rowData.batchJobId,
          batchJobHistoryUID: rowData.batchJobHistoryUID,
        },
        size: 'md',
      });
    },
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onSelectedPrg() {
      this.batchJobData.batchJobProgramId = this.selectedPrg.programId;
      this.batchJobData.batchJobProgramName = this.selectedPrg.programName;
    },
    onSearch() {
      // date picker validation
      if (this.onClickValidate()) return false;

      this.searchBatchJobHistory(this.batchJobId);

      return null;
    },
    onSave() {
      this.save();
    },
    onDelete() {
      // eslint-disable-next-line max-len
      utils.confirm(this.$t('MSG_ALT_IS_DEL_DATA'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO'), this.deleteBatchJob, () => {});
    },
    onClose() {
      this.$emit('close');
    },
    onPagePopupClose() {
    },
    onPopOpenOrClose() {
      this.isShowPopUpJobHistory = !this.isShowPopUpJobHistory;
    },
    /** ***************************************************************************
      함수 영역
      ***************************************************************************** */
    setDatePickerToSearchBox() {
      if (this.rangeDate.from != null && this.rangeDate.from !== '') {
        this.batchJobHistorySearchBox.batchJobStartDTM = utils.dateformatToServer(this.rangeDate.from);
      }

      if (this.rangeDate.to != null && this.rangeDate.to !== '') {
        this.batchJobHistorySearchBox.batchJobEndDTM = utils.dateformatToServer(this.rangeDate.to);
      }
    },
    searchBatchJob(sBatchJobId) {
      http.request(this.pageId, 'DTS_CMS_00012', {
        path: {
          'batch-job-id': utils.trim(sBatchJobId),
        },
      }).then(res => {
        const has = Object.prototype.hasOwnProperty;

        utils.forEach(res.data, (value, key) => {
          if (utils.has(this.batchJobData, key)) {
            if (has.call(this.batchJobData[key], 'key')) {
              utils.set(this.batchJobData, key, { key: value, label: '' });
            } else {
              utils.set(this.batchJobData, key, value);
            }
          }
        });

        this.batchJobData.firstRegistrationDTM = utils.dateformatToClient(this.batchJobData.firstRegistrationDTM);
        this.batchJobData.finalModificationDTM = utils.dateformatToClient(this.batchJobData.finalModificationDTM);

        this.selectedPrg.programId = this.batchJobData.batchJobProgramId;
        this.selectedPrg.programName = this.batchJobData.batchJobProgramName;
      }).catch(error => {
        console.log(error);
      });
    },
    save() {
      // form validation
      if (!this.formValidate(this.batchJobData)) {
        return false;
      }

      // searchBox -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.batchJobData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00014', { // dataservices reg.
          path: {
            'batch-job-id': utils.trim(this.batchJobData.batchJobId),
          },
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save');
          console.log(res);
        }).catch(error => {
          console.log(error);
        });
      });

      return true;
    },
    formValidate(formData) {
      if (utils.isEmpty(utils.trim(formData.moduleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.subModuleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.batchJobId))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_BCJB_ID')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.batchJobName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_BCJB_NM')));
        return false;
      }

      return true;
    },

    deleteBatchJob() {
      http.request(this.pageId, 'DTS_CMS_00015', {
        path: {
          'batch-job-id': utils.trim(this.batchJobData.batchJobId),
        },
      }).then(res => {
        utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
        this.$emit('save');
        console.log(res);
      }).catch(error => {
        console.log(error);
      });
    },

    searchBatchJobHistory(sBatchJobId) {
      this.setDatePickerToSearchBox();
      this.batchJobHistorySearchBox.batchJobId = utils.trim(sBatchJobId);
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.batchJobHistorySearchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.pageId, 'DTS_CMS_00016', {
        query: queryParams,
      }).then(res => {
        utils.forEach(res.data, item => {
          const objItem = item;
          objItem.batchJobPracticeId = { key: item.batchJobPracticeId, text: item.batchJobPracticeId };
        });

        this.dsBatchJob.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      }).catch(error => {
        console.log(error);
      });
    },

    onKeyUpInput(event, obj, sCol) {
      if (event.key !== 13) {
        const searchFieldNewText = event.target.value;

        if (utils.isExistSpecialChar(searchFieldNewText)) {
          utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
            const has = Object.prototype.hasOwnProperty;
            if (has.call(obj[sCol], 'key')) {
            // eslint-disable-next-line no-param-reassign
              obj[sCol].key = this.searchFieldOldText[sCol];
            } else {
            obj[sCol] = this.searchFieldOldText[sCol]; // eslint-disable-line
            }
          });
        } else {
          this.searchFieldOldText[sCol] = searchFieldNewText; // eslint-disable-line
        }
      }
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
